export default ['JsonRPCService', function (JsonRPCService) {
    return {
        generateUploadToken: function generateUploadToken(xCenter, service) {
            return JsonRPCService.send(xCenter, service, 'generateUploadToken', []);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/documentupload/UploadTokenService.js
// module id = 1955
// module chunks = 0